import axios from 'axios';
import Swal from 'sweetalert2';

export const dashboardLifecycle = {
    async created() {
        this.obj.html = "Loading Content...";
        await this.prepareObj();

        setTimeout(() => {
            this.obj.html = this.getHtml();
        }, 500);
    },

    mounted() {
        this.detectMobile();
        window.addEventListener('resize', this.detectMobile);

        console.log(this.app_environment);

        this.updatevhValue();
        this.emailfixersorter();
        this.loadFavoriteTiles();

        const container = document.querySelector('div');
        container.addEventListener('dragover', this.handleDragOver);
        container.addEventListener('dragleave', this.handleDragLeave);
        container.addEventListener('drop', this.handleDrop);
        container.addEventListener('dragenter', this.handleDragEnter);

        window.addEventListener('resize', this.updatevhValue);

        // Lightbox logic
        window.onclick = (e) => {
            if (e.target.tagName === 'IMG' && e.target.classList.contains('lightboxable')) {
                console.log("Lightbox clicked:", e.target.src);

                Swal.fire({
                    imageUrl: e.target.src,
                    imageWidth: '95%',
                    imageHeight: '93%',
                    imageAlt: 'Preview image',
                    width: 1000,
                    heightAuto: true,
                    showConfirmButton: false,
                    background: 'rgba(240, 240, 240, 1)',
                });
            }
        };

      // New load logic
        if (this.$store.getters.newload === true) {
            axios({
                method: 'post',
                url: this.baseAPIURL + '/apiv3/getbooksyncs.json',
                headers: {
                    auth: this.$store.getters.auth_token,
                    'Content-Type': 'multipart/form-data',
                },
            }).then((response) => {
                this.newload_data = [];

                var synced_books = Object.values(response.data.books);
                this.preload_books = Object.values(this.books);

                for (var i = 0; i < synced_books.length; i++) {
                    if (!this.preload_books.includes(synced_books[i])) {
                        this.newload_data.push(synced_books[i]);
                    }
                }
            });
        }

      // Vuex + localStorage logic
        if (localStorage.vuex) {
            this.isThereTile = true;

            if (this.$store.getters.active_books.length === 0) {
                this.$store.getters.books.map((item, index) => {
                    if (index === 0) {
                        if (this.$store.getters.selected_book === '') {
                            this.$store.dispatch('activeBook', item);
                        }
                    }
                this.$store.dispatch('setActiveBooks', item);
                });
            }

        if (this.$store.getters.books != null) {
            this.$store.getters.books.map((item) => {
                this.books.push(item);
            });

            this.$store.dispatch('unsetTiles');
            this.$store.getters.active_pages.map((item, index) => {
                if (index === 0) {
                    if (this.$store.getters.selected_page === '') {
                        this.$store.dispatch('activePage', item.title);
                    }
                }
                item.tiles.map((tile) => {
                    this.$store.getters.tiles.push({ tile });
                });
            });

        if (this.$store.getters.active_tile != null) {
            const activeTileId = this.$store.getters.active_tile.id;
            setTimeout(() => {
                this.scrollFunc(activeTileId);
            }, 10);
        }

            this.search_tile = '';
            fetch('https://api.ipify.org?format=json')
                .then((x) => x.json())
                .then(({ ip }) => {
                    this.ip_public = ip;
                });

            fetch('https://ipapi.co/' + this.ip_public + '/json')
                .then((response) => response.json())
                .then(
                (data) =>
                    (this.ip_location =
                    data.city + ',' + data.region + ',' + data.country)
                );

            this.badgePack();
            if (this.$store.getters.selected_book) {
                this.selectBook(this.$store.getters.selected_book);
            }
        }

        this.$store.dispatch('setLoading', false);
        } else {
            this.$store.dispatch('setLoading', true);
        }

        this.handledomainbooksort();
        this.checkCountTile();
        this.loadBooks();
    },

    watch: {
        '$route.query.entrytile': {
            immediate: true,
            handler(uuid) {
                if (!uuid || this.tile_loaded) return;

                //dashboardMethodTile.js method
                this.tileRedirect(uuid);
            }
        }
    },


    beforeDestroy() {
        window.removeEventListener('resize', this.updatevhValue);
        window.removeEventListener('resize', this.detectMobile);
    },
};
